import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function PNLPrint(body, name,month,year) {
    let bList = []

    body.forEach(element => {
        const b = [
            `${element.date.trim()}`,
            `${element.invoice}`,
            `${element.customer.trim()}`,
            `${element.item.trim()}`,
            printFormatNumber(element.quantity.toLocaleString()),
            printFormatNumber(element.price.toLocaleString()),
            printFormatNumber(element.cost.toLocaleString()),
            printFormatNumber(element.profit.toLocaleString()),
            printFormatNumber(element.total.toLocaleString()) ]
        bList = [...bList, b]

    })
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
    });
    const heading = ['Date', 'Folio', 'Customer', 'Item', 'Qty', 'Price', 'Cost', 'Profit', 'Total'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Profit & Loss Report", 270, 40)
    doc.text(`Month:${month}`, 20, 55)
    doc.text(`Year:${year}`, 270, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "Left"},
                2: {halign: "Left"},
                3: {halign: "Left"},
                4: {halign: "right"},
                5: {halign: "right"},
                6: {halign: "right"},
                7: {halign: "right"},
                8: {halign: "right"},
            },
        }
    )
    doc.save(`ProfitLoss-${year}-${month}.pdf`);
}



